import * as M from 'shared/types/models';

export function isMarkupByPeriodsNotAllowed(metric: M.Metric, templateMetric: M.TemplateMetric) {
  return !metric.isMarkupByPeriodsAllowed && templateMetric.periodType !== 'NONE';
}
